import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { shareReplay } from 'rxjs/operators';
import { Observable } from 'rxjs';

const API_URL = environment.apiUrl;

@Injectable({
  providedIn: 'root'
})
export class GlobalService {

  ciudades$ = this.http.get<any>(`${API_URL}/api/Global/ciudad`).pipe(
    shareReplay(1)
  );

  rhs$ = this.http.get<any>(`${API_URL}/api/Global/tipo/TipoSangre`).pipe(
    shareReplay(1)
  );

  documentos$ = this.http.get<any>(`${API_URL}/api/Global/tipo/TipoDocumento`).pipe(
    shareReplay(1)
  );

  reconocimientosCategoria$ = this.http.get<any>(`${API_URL}/api/Global/tipo/TipoReconocimientoCategoria`).pipe(
    shareReplay(1)
  );

  estadosMatricula$: Observable<any> = this.http.get<any>(`${API_URL}/api/Global/tipo/TipoMatriculaEstado`).pipe(
    shareReplay(1)
  );

  tiposMetasUnidad$: Observable<any> = this.http.get<any>(`${API_URL}/api/Categorias/U`).pipe(
    shareReplay(1)
  );

  idiomas$: Observable<any> = this.http.get<any>(`${API_URL}/api/Global/tipo/TipoIdioma`).pipe(
    shareReplay(1)
  );

  tiposEventosUnidad: Observable<any> = this.http.get<any>(`${API_URL}/api/Global/tipo/TipoEvento`).pipe(
    shareReplay(1)
  );

  estadosPermisos: Observable<any> = this.http.get<any>(`${API_URL}/api/Global/tipo/TipoEvento`).pipe(
    shareReplay(1)
  )


  constructor(private http: HttpClient) { }

  tipoGenerico(tipo) {
    return this.http.get<any[]>(`${API_URL}/api/Global/tipo/${tipo}`);
  }

  unionArrays (x, y) {
    const obj = {};
    for (let i = x.length - 1; i >= 0; -- i) {
      if (obj[x[i].id]) {
        obj[x[i].id] = x[i];
      } else {
        obj[x[i]] = x[i];
      }
    }
    for (let i = y.length - 1; i >= 0; -- i) {
      if (y[i].id) {
        obj[y[i].id] = y[i];
      } else {
        obj[y[i]] = y[i];
      }
    }
    const res = [];
    for (const k in obj) {
      if (obj.hasOwnProperty(k)) {
        res.push(obj[k]);
      }
    }
    return res;
  }

  intersectionArrays(x,y) {
    const objx = {};
    const objy = {};
    for (let i = x.length - 1; i >= 0; -- i) {
      if (objx[x[i].id]) {
        objx[x[i].id] = x[i];
      } else {
        objx[x[i]] = x[i];
      }
    }
    for (let i = y.length - 1; i >= 0; -- i) {
      if (y[i].id) {
        objy[y[i].id] = y[i];
      } else {
        objy[y[i]] = y[i];
      }
    }
    const res = [];
    for (const k in objx) {
      if (objy.hasOwnProperty(k)) {
        res.push(objy[k]);
      }
    }
    return res;
  }

  unique(array: string[]) {
    return array.filter((value, index) => array.indexOf(value) === index);
  }


  // Taken from https://github.com/aceakash/string-similarity/blob/master/src/index.js
  compareTwoStrings(first, second) {
    first = first.replace(/\s+/g, '');
    second = second.replace(/\s+/g, '');

    if (!first.length && !second.length) {return 1; }           // if both are empty strings
    if (!first.length || !second.length) {return 0; }           // if only one is empty string
    if (first === second) {return 1; }       							      // identical
    if (first.length === 1 && second.length === 1) {return 0; } // both are 1-letter strings
    if (first.length < 2 || second.length < 2) {return 0;	}		  // if either is a 1-letter string

    const firstBigrams = new Map();
    for (let i = 0; i < first.length - 1; i++) {
      const bigram = first.substring(i, i + 2);
      const count = firstBigrams.has(bigram)
        ? firstBigrams.get(bigram) + 1
        : 1;

      firstBigrams.set(bigram, count);
    };

    let intersectionSize = 0;
    for (let i = 0; i < second.length - 1; i++) {
      const bigram = second.substring(i, i + 2);
      const count = firstBigrams.has(bigram)
        ? firstBigrams.get(bigram)
        : 0;

      if (count > 0) {
        firstBigrams.set(bigram, count - 1);
        intersectionSize++;
      }
    }

    return (2.0 * intersectionSize) / (first.length + second.length - 2);
  }

  areArgsValid(mainString, targetStrings) {
    if (typeof mainString !== 'string') { return false; }
    if (!Array.isArray(targetStrings)) { return false; }
    if (!targetStrings.length) { return false; }
    if (targetStrings.find(s => typeof s !== 'string')) { return false; }
    return true;
  }

  findBestMatch(mainString, targetStrings) {
    if (!this.areArgsValid(mainString, targetStrings)) {
      throw new Error('Bad arguments: First argument should be a string, second should be an array of strings');
    }

    const ratings = [];
    let bestMatchIndex = 0;

    for (let i = 0; i < targetStrings.length; i++) {
      const currentTargetString = targetStrings[i];
      const currentRating = this.compareTwoStrings(mainString, currentTargetString);
      ratings.push({target: currentTargetString, rating: currentRating});
      if (currentRating > ratings[bestMatchIndex].rating) {
        bestMatchIndex = i;
      }
    }

    const bestMatch = ratings[bestMatchIndex];

    return { ratings, bestMatch, bestMatchIndex };
  }

  textNormalize(text) {
    return text.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  }

  contieneTexto(texto, textoBuscar) {
    let res = true;
    if (texto) {
      texto.split(' ').forEach(element => {
        if (!textoBuscar.includes(element)) {
          res = false;
        }
      });
    }
    return res;
  }

}
